class HtmlElementHelper {
    public isFocusedElement(inputElement: HTMLElement): boolean {
        return inputElement === document.activeElement;
    }

    public isEventTargetFocusedElement(eventTarget: EventTarget | null): boolean {
        if (eventTarget !== null && eventTarget instanceof HTMLElement) {
            return this.isFocusedElement(eventTarget);
        }

        return false;
    }

    public isValidNumberInput(inputElement: HTMLInputElement) {
        const numericValue = Number(inputElement.value);

        if (isNaN(numericValue)) {
            return false;
        }

        if (inputElement.min.length > 0) {
            if (numericValue < Number(inputElement.min)) {
                return false;
            }
        }

        if (inputElement.max.length > 0) {
            if (numericValue > Number(inputElement.max)) {
                return false;
            }
        }

        return true;
    }
}

export default new HtmlElementHelper();
